import { fetchJSON } from '@ratehub/base-ui';

/**
 * Fetch deposit products according to options
 * @param {object} options
 * @param {string} options.province - Province code
 * @param {string} options.language - Language code
 * @param {object[]} options.products - An array of requested products ordered by priority
 * @param {string} apiRoute
 * @returns {Promise<object>}
 */
export default async function fetchDeposit(options, apiRoute) {
    const params = {
        province: options.province,
        language: options.language,
        placements: options.products,
    };

    return await fetchJSON({
        url: apiRoute,
        options: {
            method:  'POST',
            headers: { 'Content-Type': 'application/json' },
            body:    JSON.stringify(params),
        },
    }, 'fetchDeposit');
}
